import React, { useState, useEffect, useMemo } from "react";
import { DateTime } from "luxon";
import fetchApi from "../../fetchApi";
import EventCard from "../../components/event/EventCard";

const today = DateTime.now();

const Events = ({ title }) => {
  const [events, setEvents] = useState([]);
  const upcomingEvents = useMemo(() => getUpcomingEvents(events), [events]);
  const pastEventsCount = useMemo(() => events.length - upcomingEvents.length, [
    events,
    upcomingEvents,
  ]);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const fetchedEvents = await fetchApi("/event");
      setEvents(fetchedEvents);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="oHomeEvents" id="events">
      <h1 className="oHomeEvents_title">{title}</h1>
      <div className="oHomeEvents_count text only-mobile">
        {getPastEventText(pastEventsCount)}
      </div>
      <div className="oHomeEvents_slider">
        <div className="oHomeEvents_count text only-desktop">
          {getPastEventText(pastEventsCount)}
        </div>
        <div className="oHomeEvents_cards">
          {sortEvents(upcomingEvents).map((event) => (
            <div className="oHomeEvents_card" key={event.id}>
              <EventCard {...event} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const getUpcomingEvents = (events) =>
  events.filter((event) => {
    const eventDate = DateTime.fromFormat(event.date, "D", { locale: "fr" });
    return eventDate.endOf("day") > today;
  });

const sortEvents = (events) =>
  events.slice().sort((eventA, eventB) => {
    const dateA = DateTime.fromFormat(eventA.date, "D", { locale: "fr" });
    const dateB = DateTime.fromFormat(eventB.date, "D", { locale: "fr" });
    return dateA - dateB;
  });

const getPastEventText = (pastEventsCount) => {
  if (pastEventsCount < 2) return `${pastEventsCount} past event`;
  else return `${pastEventsCount} past events`;
};

export default Events;
